module.exports = __webpack_public_path__ + "img/bether_logo_big_black.4a418f28.png";